import React from "react";
import { Avatar, styled } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";

const AccountAvatarStyled = styled(Avatar)(({ theme }) => ({
  width: 36,
  height: 36,
  borderRadius: "50%",
  backgroundColor: theme.palette.grey[300],
  [theme.breakpoints.up("sm")]: {
    width: 60,
    height: 60,
  },
}));

const PersonIconStyled = styled(PersonIcon)(({ theme }) => ({
  color: theme.palette.action.active,
  fontSize: 22,
  [theme.breakpoints.up("sm")]: {
    fontSize: 32,
  },
}));

interface AccountAvatarProps {
  picture?: string;
}

export const AccountAvatar: React.FC<AccountAvatarProps> = ({ picture }) => {
  return (
    <AccountAvatarStyled alt="Avatar de Cuenta" src={picture || undefined}>
      {!picture && <PersonIconStyled />}
    </AccountAvatarStyled>
  );
};
